export default __webpack_public_path__ + "0956c2ad1b6f4e058252f4b06dd7a6bb.svg";